// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import MetaInfo from 'vue-meta-info'
import VueI18n from 'vue-i18n'
import MuseUI from 'muse-ui'
import vueResource from 'vue-resource'
import './assets/css/muse-theme.less';
import 'muse-ui/dist/muse-ui.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper);
Vue.use(MetaInfo);
Vue.config.productionTip = false

require('./assets/css/reset.css');
Vue.use(VueI18n);
Vue.use(MuseUI)
Vue.use(vueResource);


const i18n=new VueI18n(
  {
    locale:function(){
        var lang=(navigator.language||navigator.userLanguage).substr(0,2);
        // return lang||'zh';
        return 'zh';//目前只要中文
    }(),
    messages: {
      'zh': require('./assets/js/zh'),
      'en': require('./assets/js/en')
    }
  }
)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,

  components: { App},
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js